@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Learner's Key Stage:</div>
            <div class="kvp__k tw:py-1">Learner's Learning Band:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ keyStageText }} &nbsp;</div>
            <div class="kvp__v tw:py-1">{{ learningBandText }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Progress Towards Target:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.comments }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Target For Next Period:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.target }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learner Comments:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learnerComments }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
